import Axios from '../../helpers/api_client';

export function fetchBranchAPI(filters = {}) {
  let query = 'utility/branches?';

  if (Object.keys(filters).length) {
    for (var i in filters) {
      query += i + '=' + filters[i] + '&';
    }
  }
  return Axios.get(process.env.REACT_APP_API_HRMS_BASE_URL + query, {
    body: null,
    headers: {authorization: null},
  }).then((res) => {
    if (res.status !== 200) throw res.data.message;
    return res.data;
  });
}

export function fetchDepartmentAPI(filters = {}) {
  let query = 'utility/departments?';

  if (Object.keys(filters).length) {
    for (var i in filters) {
      query += i + '=' + filters[i] + '&';
    }
  }
  return Axios.get(process.env.REACT_APP_API_HRMS_BASE_URL + query, {
    body: null,
    headers: {authorization: null},
  }).then((res) => {
    if (res.status !== 200) throw res.data.message;
    return res.data;
  });
}

export function fetchContractTypeListAPI(filters = {}) {
  let query = 'utility/contract-type-list?';

  if (Object.keys(filters).length) {
    for (var i in filters) {
      query += i + '=' + filters[i];
    }
  }
  return Axios.get(process.env.REACT_APP_API_HRMS_BASE_URL + query, {
    body: null,
    headers: {authorization: null},
  }).then((res) => {
    if (res.status !== 200) throw res.data.message;
    return res.data;
  });
}
